module.exports = __webpack_public_path__ + "img/6.b335e75c.png";